/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_StopInputs */



/**
* | output |
* | --- |
* | "Stop" |
*
* @param {Meeting_Offline_StopInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_stop = /** @type {((inputs?: Meeting_Offline_StopInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_StopInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Stoppen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Arrêter")
	return /** @type {LocalizedString} */ ("Stop")
});